import { BackLink } from '@/components/BackLink';
import { type AdItemType } from '@/resource/ad';
import { RouteType } from '@/util/routeToPath';
import { useEffect, useState } from 'react';
import { create } from 'zustand';

// The backroute should be set on any page that displays a list of ads
// so we can always provide the correct backlink. history.go(-1) isn't
// really an option because it doesn't work if you come from a different
// page like the edit ad page which would cause an infinite back and forth.
export const useAdDetailBackRoute = create<{
  route?: RouteType;
}>(() => ({}));

type Props = {
  ad: AdItemType;
};

export function AdBackLink({ ad }: Props) {
  const [backRoute, setBackRoute] = useState<RouteType>({
    type: `market_${ad.type}s`,
  });

  useEffect(() => {
    setBackRoute(
      useAdDetailBackRoute.getState().route || {
        type: `market_${ad.type}s`,
      }
    );
  }, [ad.type]);

  return <BackLink to={backRoute} title="Terug" />;
}
